module.exports = __webpack_public_path__ + "static/media/6.b89db68c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/6.jpg
// module id = 1347
// module chunks = 0